/**
 * Product Data - Fairy garden miniatures and accessories
 */

import type { Product } from '../types';

// Fiary door product images

// Garden creatures product images
import bunnyGroup from './images/bunny-group-painted.jpg';
import cedarlightDoorWindow from './images/cedarlight-door-window-painted.jpg';

// Accessories product images
import fairyBalcony2 from './images/fairy-balcony-painted-1.jpg';
import fairyBalcony3 from './images/fairy-balcony-painted-2.jpg';
import fairyFence1 from './images/fairy-fence-painted-1.jpg';
import fairyFence2 from './images/fairy-fence-painted-2.jpg';
import fairyFence3 from './images/fairy-fence-raw-1.jpg';
import fairySignpost from './images/fairy-signposts-painted.jpg';
import fairyBalcony from './images/fairy_balcony_print_1.jpg';
import festiveDoorWindow from './images/festive-door-painted.jpg';
import festiveDoorWindow2 from './images/festive-door-print.jpg';
import loveyMushroom from './images/lovey-mushroom.jpg';
import mushroomGang from './images/mushroom-gang-painted.jpg';
import oakenheartDoorWindow from './images/oakenheart-door-window-painted.jpg';
import regalDoorWindow from './images/regal-door-window-painted.jpg';
import solaris from './images/solaris-painted.jpg';
import starryMushroom from './images/starry-mushroom.jpg';
import verdantDoorWindow2 from './images/verdant-door-window-2.jpg';
import verdantDoorWindow from './images/verdant-door-window-painted.jpg';
import wellyMushroom from './images/welly-mushroom.jpg';
import wistfulDoorWindow from './images/wistful-door-window-painted.jpg';

export const products: Product[] = [
  {
    id: 'verdant-fairy-door',
    name: 'Verdant Fairy Door & Window Set',
    description:
      'A charming woodland fairy door with matching window, adorned with delicate vines and flowers. Perfect for creating a magical entrance in your garden or at the base of a tree.',
    price: 24.99,
    image: verdantDoorWindow,
    images: [verdantDoorWindow, verdantDoorWindow2],
    category: 'Fairy Doors',
    inStock: true,
    featured: true,
    variants: [
      {
        id: 'verdant-stl',
        label: 'STL File',
        price: 12.99,
        kind: 'stl',
        inStock: true,
      },
      {
        id: 'verdant-painted',
        label: 'Hand Painted',
        price: 24.99,
        kind: 'painted',
        inStock: true,
      },
    ],
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-fairy-garden-verdant-door-and-window-423980',
      cults: 'https://cults3d.com/en/3d-model/verdant-fairy-door',
      makerworld: 'https://makerworld.com/model/verdant-fairy-door',
    },
  },
  {
    id: 'wistful-fairy-door',
    name: 'Wistful Fairy Door & Window',
    description:
      'An elegant arched fairy door with intricate scrollwork and a dreamy, ethereal design. The matching window features a crescent moon motif.',
    price: 27.99,
    image: wistfulDoorWindow,
    images: [wistfulDoorWindow],
    category: 'Fairy Doors',
    inStock: true,
    stlLinks: {
      myminifactory: 'https://myminifactory.com/object/wistful-fairy-door',
      cults: 'https://cults3d.com/en/3d-model/wistful-fairy-door',
    },
  },
  {
    id: 'oakenheart-fairy-door',
    name: 'Oakenheart Fairy Door & Window',
    description:
      'A rustic, sturdy fairy door inspired by ancient oak trees. Features bark-like texturing and acorn decorations. Built to withstand the elements.',
    price: 29.99,
    image: oakenheartDoorWindow,
    images: [oakenheartDoorWindow],
    category: 'Fairy Doors',
    inStock: true,
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-fairy-garden-rounded-door-and-window-360796',
      cults: 'https://cults3d.com/en/3d-model/oakenheart-fairy-door',
    },
  },
  {
    id: 'cedarlight-fairy-door',
    name: 'Cedarlight Fairy Door & Window',
    description:
      'A warm, inviting fairy door with lantern details that seem to glow with inner light. The cedar-inspired design brings warmth to any fairy garden.',
    price: 26.99,
    image: cedarlightDoorWindow,
    images: [cedarlightDoorWindow],
    category: 'Fairy Doors',
    inStock: true,
    rating: 4.8,
    reviews: 52,
    stlLinks: {
      myminifactory: 'https://myminifactory.com/object/oakenheart-fairy-door',
      cults: 'https://cults3d.com/en/3d-model/oakenheart-fairy-door',
    },
  },
  {
    id: 'regal-fairy-door',
    name: 'Regal Fairy Door & Window',
    description:
      'An ornate, palace-inspired fairy door fit for fairy royalty. Features crown motifs, gemstone details, and an elegant peaked arch design.',
    price: 32.99,
    image: regalDoorWindow,
    images: [regalDoorWindow],
    category: 'Fairy Doors',
    inStock: true,
    rating: 5.0,
    reviews: 41,
    featured: true,
    variants: [
      {
        id: 'regal-stl',
        label: 'STL File',
        price: 14.99,
        kind: 'stl',
        inStock: true,
      },
      {
        id: 'regal-painted',
        label: 'Hand Painted',
        price: 32.99,
        kind: 'painted',
        inStock: true,
      },
    ],
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-fairy-garden-arched-door-and-window-370832',
      cults: 'https://cults3d.com/en/3d-model/regal-fairy-door',
    },
  },
  {
    id: 'solaris-fairy-door',
    name: 'Solaris Fairy Door & Window',
    description:
      'A magical solar-powered fairy door with intricate sun motifs. Charges during the day and casts a warm, enchanting glow through your fairy garden at night.',
    price: 32.99,
    image: solaris,
    images: [solaris],
    category: 'Fairy Doors',
    inStock: true,
    rating: 5.0,
    reviews: 41,
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-fairy-garden-solaris-door-and-window-394543',
      cults: 'https://cults3d.com/en/3d-model/regal-fairy-door',
    },
  },
  {
    id: 'festive-fairy-door',
    name: 'Festive Fairy Door & Window',
    description:
      'A magical festive fairy door with intricate holiday motifs. Perfect for creating a magical entrance in your garden or at the base of a tree during the holidays.',
    price: 32.99,
    image: festiveDoorWindow,
    images: [festiveDoorWindow, festiveDoorWindow2],
    category: 'Fairy Doors',
    inStock: true,
    rating: 5.0,
    reviews: 41,
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-fairy-festive-door-and-window-729556',
      cults: 'https://cults3d.com/en/3d-model/regal-fairy-door',
    },
  },
  {
    id: 'starry-mushroom',
    name: 'Starry the Mushroom',
    description:
      'A whimsical mushroom decorated with stars and moon patterns. The cap features a tiny chimney and windows that light up the night.',
    price: 18.99,
    image: starryMushroom,
    images: [starryMushroom],
    category: 'Garden Creatures',
    inStock: true,
    rating: 4.6,
    reviews: 73,
    featured: true,
    isNew: true,
  },
  {
    id: 'lovey-mushroom',
    name: 'Lovie the Mushroom',
    description:
      'An adorable mushroom with heart-shaped windows and a cozy, romantic design. Perfect for fairy couples or as a Valentine garden accent.',
    price: 19.99,
    image: loveyMushroom,
    images: [loveyMushroom],
    category: 'Garden Creatures',
    inStock: true,
    stlLinks: {
      makerworld: '',
    },
  },
  {
    id: 'welly-mushroom',
    name: 'Welly Mushroom',
    description:
      'A cheerful mushroom offering up a tiny beef wellington on a plate.',
    price: 24.99,
    image: wellyMushroom,
    images: [wellyMushroom],
    category: 'Garden Creatures',
    inStock: true,
    stlLinks: {
      makerworld: 'https://makerworld.com/model/welly-mushroom',
    },
  },
  {
    id: 'mushroom-gang',
    name: 'Mushroom Gang Set',
    description:
      'A delightful collection of six miniature mushroom friends, each with unique expressions and personalities. Perfect for creating a mushroom village, holding in your palm or tucking into a bag pocket to take whenever needed!',
    price: 29.99,
    image: mushroomGang,
    images: [mushroomGang],
    category: 'Garden Creatures',
    inStock: true,
    featured: true,
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-cute-mushie-gang-475398',
      cults: '',
    },
  },
  {
    id: 'bunny-group',
    name: 'Woodland Bunny Family',
    description:
      'An enchanting family of four garden bunnies in various poses. Hand-painted with loving detail, these bunnies add life to any fairy garden.',
    price: 28.99,
    image: bunnyGroup,
    images: [bunnyGroup],
    category: 'Garden Creatures',
    inStock: true,
    featured: true,
    isNew: true,
    stlLinks: {
      myminifactory:
        'https://www.myminifactory.com/object/3d-print-woodland-bunny-family-494614',
      cults: 'https://cults3d.com/en/3d-model/woodland-bunny-family',
    },
  },
  {
    id: 'fairy-balcony',
    name: 'Fairy Balcony',
    description:
      'A beautiful miniature balcony with flower boxes and trailing vines. Attaches to tree trunks or garden walls to create elevated fairy living spaces.',
    price: 9.99,
    image: fairyBalcony3,
    images: [fairyBalcony, fairyBalcony2, fairyBalcony3],
    category: 'Fairy Accessories',
    inStock: true,
    featured: true,
    isNew: true,
    stlLinks: {
      myminifactory: 'https://myminifactory.com/object/fairy-balcony',
      cults: 'https://cults3d.com/en/3d-model/fairy-balcony',
    },
  },
  {
    id: 'fairy-fence',
    name: 'Fairy Rustic Fence',
    description:
      'A beautiful miniature rustic fence, including a gate and arched entranceway.',
    price: 9.99,
    image: fairyFence1,
    images: [fairyFence1, fairyFence2, fairyFence3],
    category: 'Fairy Accessories',
    inStock: true,
    stlLinks: {
      myminifactory: 'https://myminifactory.com/object/fairy-balcony',
      cults: 'https://cults3d.com/en/3d-model/fairy-balcony',
    },
  },
  {
    id: 'fairy-signpost',
    name: 'Fairy Rustic Signpost',
    description:
      'A quaint miniature rustic signpost, help those fairies find their way home!',
    price: 9.99,
    image: fairySignpost,
    images: [fairySignpost],
    category: 'Fairy Accessories',
    inStock: true,
    stlLinks: {
      myminifactory: 'https://myminifactory.com/object/fairy-balcony',
      cults: 'https://cults3d.com/en/3d-model/fairy-balcony',
    },
  },
];

/**
 * Get all unique categories from products
 */
export const getCategories = (): string[] => {
  const categories = new Set(products.map((p) => p.category));
  return Array.from(categories).sort();
};

/**
 * Get a product by its ID
 */
export const getProductById = (id: string): Product | undefined =>
  products.find((p) => p.id === id);

/**
 * Get products by category
 */
export const getProductsByCategory = (category: string): Product[] =>
  products.filter((p) => p.category === category);

export const getFeaturedProducts = (): Product[] => {
  const featured = products.filter((p) => p.featured);
  return featured.length > 0 ? featured : products.slice(0, 6);
};

export const getRelatedProducts = (product: Product, limit = 4): Product[] =>
  products
    .filter((p) => p.category === product.category && p.id !== product.id)
    .slice(0, limit);
